
































import {
  defineComponent, ref, useContext, useRoute,
} from '@nuxtjs/composition-api';
import { SfImage } from '@storefront-ui/vue';
import DOMPurify from 'isomorphic-dompurify';
import BKButton from '~/components/BK/BKButton.vue';

const SUPPORTED_GIFT_CARDS = new Set(['50', '100', '200', '500']);
export default defineComponent({
  components: {
    SfImage,
    BKButton,
  },
  setup() {
    const { $config } = useContext();
    const {
      giftCard50ImageUrl, giftCard100ImageUrl, giftCard200ImageUrl, giftCard500ImageUrl,
    } = $config;
    const route = useRoute();

    const { amount } = route.value.query;

    const hasError = ref(false);
    let imageUrl = '';

    if (typeof amount !== 'string') {
      hasError.value = true;
    } else {
      // valid input formats: 200,01%20€ or 100.00%20€
      // we need to extract the number part before the comma or dot, and in case delete the currency in front
      const cleanedAmount = DOMPurify.sanitize(amount as string).replace(/^\D+/, '');
      const parts = cleanedAmount.split(/[,.]/);
      const parsedAmount = parts[0] || '';

      if (!SUPPORTED_GIFT_CARDS.has(parsedAmount)) {
        hasError.value = true;
      } else {
        switch (parsedAmount) {
          case '50':
            imageUrl = giftCard50ImageUrl as string;
            break;
          case '100':
            imageUrl = giftCard100ImageUrl as string;
            break;
          case '200':
            imageUrl = giftCard200ImageUrl as string;
            break;
          case '500':
            imageUrl = giftCard500ImageUrl as string;
            break;
          default:
            hasError.value = true;
            break;
        }
      }
    }

    function openAndPrintImage() {
      if (!imageUrl) return;
      const printWindow = window.open('', '_blank');
      if (printWindow) {
        printWindow.document.write(`
        <html>
          <head>
            <title>Gutschein drucken</title>
            <style>
              body { margin: 0; display: flex; align-items: center; justify-content: center; height: 100vh; }
              img { max-width: 100%; max-height: 100vh; }
            </style>
          </head>
          <body>
            <img src="${imageUrl}" onload="window.print();window.close();" />
          </body>
        </html>
      `);
        printWindow.document.close();
      }
    }

    return {
      hasError,
      imageUrl,
      openAndPrintImage,
    };
  },
});
